import { gql, type TypedDocumentNode } from "@apollo/client";
import { type GQL } from "@binale-tech/shared";

/**
 * Recording that a user accepted a published legal document.
 *
 * Shared across layers - the account-level acceptances (AGB + Datenschutzerklärung)
 * are recorded at registration by `@app/pages/auth/RegisterView`, while the AVV is
 * recorded per company during the company hand-over. Lives in @domain so neither
 * feature has to reach into the other.
 *
 * The input deliberately carries **no version**: the server stamps the version of the
 * text that is currently published, because a client-supplied version would be
 * forgeable and therefore worthless as evidence of contract formation.
 * `companyId` stays omitted for account-level acceptances (AGB, PRIVACY).
 *
 * Written WITHOUT template interpolation so that scripts/validate-graphql.mjs
 * (which skips any tagged template containing an interpolation) validates it.
 */
export const legalAcceptanceRecord: TypedDocumentNode<
    Pick<GQL.IMutation, "legalAcceptanceRecord">,
    GQL.IMutationLegalAcceptanceRecordArgs
> = gql`
    mutation legalAcceptanceRecord($input: LegalAcceptanceInput!) {
        legalAcceptanceRecord(input: $input)
    }
`;
